import React, { useState } from "react";
import Modal from "../../../components/Modal";

const TERMINATION_REASONS = [
  "Parent Not Responding",
  "Requirement Cancelled",
  "No Match",
  "Invalid Lead",
  "Budget Too Low",
  "Other",
];

export default function TerminateModal({ setTerminateItem, onClick, item }) {
  const [terminationReason, setTerminationReason] = useState("");
  const [loading, setLoading] = useState(false);

  return (
    <Modal title="Terminate Enquiry" size="md">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onClick(
            e,
            { _id: item._id, terminationReason },
            setLoading
          );
        }}
      >
        <div className="modal-inner-content">
          <div className="input-group">
            <label>Reason for Termination*</label>
            <select
              className="text-input"
              required
              value={terminationReason}
              onChange={(e) => setTerminationReason(e.target.value)}
            >
              <option value="">Select reason</option>
              {TERMINATION_REASONS.map((reason) => (
                <option key={reason} value={reason}>
                  {reason}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="modal-footer">
          <input
            type="button"
            className="xs-neutral-btn"
            onClick={() => setTerminateItem(false)}
            value="Don't Terminate"
          />
          <input
            type="submit"
            className="xs-delete-btn"
            disabled={loading || !terminationReason}
            value="Terminate"
          />
        </div>
      </form>
    </Modal>
  );
}
